import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, TextArea, SubmitBtn, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import { currentDateAndTime, decodeData } from '../../Constants/constants';
class Locations extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            location_id: 0,
            esic_location_id: 0,
            keyword: '',
            esic_keyword: '',
            location_latlng: '',
            location_title: '',
            esic_location_title: '',
            location_switch: false,
            valid_attendance_distance: '',
            auto_ot_calculation: '1',
            location_address: '',
            location_description: '',
            rows: [],
            esic_rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            esic_next: false,
            esic_prev: false,
            esic_page: 1,
            esic_limit: 10,
            esic_total_records: 0,
            esic_total_pages: 0,
            loadingList: false,
            postLoading: false,
            errors: {},
            decodedData: [],
            isLocationModal: false,
            isEsicLocationModal: false,

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetListEsicLocations();
        })
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }
    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }),()=>{
            if(this.state.location_switch && name === "esic_keyword" && !value) this.GetListEsicLocations();
            else if(!this.state.location_switch && name === "keyword" && !value) this.GetList();
        });
    };
    GetInfo = (row,isEsic) => {
        // const { apiURL, apiHeaderJSON } = this.context;
        // const headers = apiHeaderJSON;
        // axios.get(`${apiURL}Masters/GetLocationInfo?location_id=${this.state.location_id}`, { headers }).then((response) => {
        //     const { data, success } = response.data;
        //     if (success === true) {
        //         this.setState(
        //             {
        //                 location_title: data[0].location_title,
        //                 valid_attendance_distance: data[0].valid_attendance_distance,
        //                 auto_ot_calculation: data[0].auto_ot_calculation,
        //                 location_address: data[0].location_address,
        //                 location_description: data[0].location_description,
        //                 location_latlng: data[0].location_latlng,
        //             }
        //         )
        //     }
        // });
        if(isEsic==="esic"){
            this.setState({
                isEsicLocationModal: true,
                esic_location_title: row?.esic_location_title,   
            });
        }
        else{
            this.setState({
                isLocationModal: true,
                location_title: row?.location_title,
                valid_attendance_distance: row?.valid_attendance_distance,
                auto_ot_calculation: row?.auto_ot_calculation,
                location_address: row?.location_address,
                location_description: row?.location_description,
                location_latlng: row?.location_latlng,
                errors:{
                    ...this.state.errors,
                    location_title:"",
                }
            });
        }
    }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetLocationList`, { params: { keyword: this.state.keyword, limit: this.state.limit, page: this.state.page }, headers }).then((response) => {

            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }
    GetListEsicLocations = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetESICLocationList`, { params: { keyword: this.state.esic_keyword, limit: this.state.limit, page: this.state.esic_page }, headers }).then((response) => {

            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    esic_rows: data.data,
                    esic_next: data.next,
                    esic_prev: data.prev,
                    esic_page: data.page,
                    esic_total_records: data.total_records,
                    esic_total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors,postLoading:false,  });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {
            location_title: this.state.location_title,
            valid_attendance_distance: this.state.valid_attendance_distance,
            auto_ot_calculation: this.state.auto_ot_calculation,
            location_address: this.state.location_address,
            location_description: this.state.location_description,
            location_latlng: this.state.location_latlng,
            date: currentDateAndTime()
        }
        if (this.state.location_id !== 0) {
            formData.location_id = this.state.location_id;
        }

        axios.post(`${apiURL}Masters/CreateLocation`, formData, { headers }).then((response) => {
            const { success } = response.data;
            if (success === true) {
                this.resetForm();
                this.setState({ postLoading:false, loadingList: true }, (prevState) => {
                    this.GetList();
                })
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
            } else {
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
                this.setState({ postLoading:false,})
            }

        }).catch((error)=>{
            this.setState({ postLoading:false })
        });
    };
    handleSubmitEsic = (e) => {
        e.preventDefault();
        const errors = this.validateForm("esic");
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {
            esic_location_title: this.state.esic_location_title,
            date: currentDateAndTime(),
        }
        if (this.state.esic_location_id !== 0) {
            formData.esic_location_id = this.state.esic_location_id;
        }

        axios.post(`${apiURL}Masters/CreateUpdateESICLocation`, formData, { headers }).then((response) => {
            const { success } = response.data;
            if (success === true) {
                this.resetForm();
                this.setState({ postLoading:false, loadingList: true }, (prevState) => {
                    this.GetListEsicLocations();
                })
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                            allowOutsideClick:false
                })
            } else {
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                            allowOutsideClick:false
                })
                this.setState({ postLoading:false, loadingList: true })
            }

        }).catch((error)=>{
            this.setState({ postLoading:false, loadingList: true })
        });
    };
    resetForm = () => {
        this.setState({
            location_id: 0,
            esic_location_id: 0,
            location_title: '',
            esic_location_title: '',
            valid_attendance_distance: '',
            location_description: '',
            location_address: '',
            auto_ot_calculation: '1',
            location_latlng: '',
            status: '',
            errors: {}
        });
    }

    validateForm = (isEsic) => {
        const errors = {};

        if(isEsic==="esic"){
            if (!this.state.esic_location_title) {
                errors.esic_location_title = 'Location title is required';
            }
        }
        else{
            if (!this.state.location_title) {
                errors.location_title = 'Location title is required';
            }
            // if (!this.state.valid_attendance_distance) {
            //     errors.valid_attendance_distance = 'Valid attendance distance is required';
            // }
            // if (!this.state.location_description) {
            //     errors.location_description = 'Location description is required';
            // }
            // if (!this.state.location_latlng) {
            //     errors.location_latlng = 'Location latitude longitude is required';
            // } else if (!this.isValidLatLng(this.state.location_latlng)) {
            //     errors.location_latlng = 'Location latitude longitude is invalid';
            // }
        }
        return errors;
    };

    isValidLatLng = (latlng) => {
        const regex = /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/;
        return regex.test(latlng);
    };

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    location_id: id,
                    date: currentDateAndTime()
                };
                axios
                    .post(`${apiURL}Masters/DeleteLocation`, formData, { headers })
                    .then((response) => {

                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            showConfirmButton: true,
                            allowOutsideClick:false
                        })
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick:false
                        })
                    });
            }
        });
    }
    handleDeleteEsicLocation = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    esic_location_id: id,
                    date: currentDateAndTime(),
                };
                axios
                    .post(`${apiURL}Masters/DeleteESICLocation`, formData, { headers })
                    .then((response) => {

                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            showConfirmButton: true,
                            allowOutsideClick:false
                        })
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetListEsicLocations();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick:false
                        })
                    });
            }
        });
    }

    handlePrev = (type) => {
        const name= type==="1"? "page":"esic_page"
        console.log("name,type",name,type);
        console.log(this.state.prev);
        if ((this.state.prev === true) || (this.state.esic_prev === true)) {
            this.setState({
            [name]:  type==="1"?  this.state.page - 1 : this.state.esic_page - 1
            }, () => {
                console.log("this.state.page",this.state.page);
                console.log("this.state.esic_page",this.state.esic_page);
                if(type==="1"){
                    this.GetList();   
                }
                else{
                    this.GetListEsicLocations();
                }
            });
        }
    }
    handleNext = (type) => {
        const name= type==="1"? "page":"esic_page"
        console.log("name,type",name,type);
        if ((this.state.next === true) || (this.state.esic_next === true)) {
            this.setState({
               [name]: type==="1"?  this.state.page + 1 : this.state.esic_page + 1
            }, () => {
                console.log("this.state.page",this.state.page);
                console.log("this.state.esic_page",this.state.esic_page);
                if(type==="1"){
                 this.GetList();   
                }
                else{
                    this.GetListEsicLocations();
                }
            });
        }
    }
    handleChange = (e,type) => {
        const name= type==="1"? "page":"esic_page"
        const { value } = e.target;
        this.setState((prevState) => {
            return { [name]: parseInt(value) };
        }, () => {
            if(type==="1"){
             this.GetList();       
            }
            else{
                this.GetListEsicLocations();
            }
        });
    }
    handleLimitChange = (e, type) => {
         const name= type==="1"? "limit":"esic_limit"
         const pageName= type==="1"? "page":"esic_page"
        const { value } = e.target;
        this.setState((prevState) => {
            return { [name]: parseInt(value), [pageName]: 1 };
        },
        () => {
            if(type==="1"){
             this.GetList();       
            }
            else{
                this.GetListEsicLocations();
            }
        }
        );
    };
    handleInputSearch = () => {
        if(this.state.location_switch){
         this.GetListEsicLocations();
        }
        else{
            this.GetList();
        }
    }
    handleClearAll = () => {
        if(this.state.location_switch){
            this.setState({
                esic_keyword: "",
            }
            , () => {
                this.GetListEsicLocations();
            });
        }
        else{
            this.setState({
                keyword: "",
            }
            , () => {
                this.GetList();
            });
        }
    };
    handleRadioChange = (name, value) => {

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    render() {
        const { errors } = this.state;
        const limitOptions = [10, 25, 50, 100, 200, 500];
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Locations Master`} primary={`Home`} />
                        <div className='card'>
                            <div className="card-header align-items-center d-flex">
                                <h4 className="card-title mb-0 flex-grow-1">{!this.state.location_switch? " Locations":" ESIC Locations"}</h4>
                                <button  className={`btn btn-info btn-label`} 
                                onClick={() => { this.setState({location_switch :!this.state.location_switch})}} >
                                    <i className={` ri-switch-line label-icon align-middle fs-16 ms-2`} />
                                    {this.state.location_switch? " Locations":" ESIC Locations"}</button>
                            </div>
                            <div className=' card-body pt-0'>
                                {!this.state.location_switch?
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className=" card-body align-items-end justify-content-between d-flex">
                                            <div className='  '>
                                                <label htmlFor="keyword">Location Title</label>
                                                <div className="input-group">
                                                    <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search Location" />
                                                    <button className="btn btn-success" onClick={this.handleInputSearch} type="button"><i className="ri-search-line"></i></button>
                                                    <button className="btn btn-secondary ms-3" disabled={!this.state.keyword} onClick={this.handleClearAll} type="button">Clear</button>
                                                </div>
                                            </div>
                                            { this.state.decodedData?.includes(2) && (
                                            <div className=''>
                                                <button style={{ float: "right"}} onClick={()=>{ this.setState({ location_id:0, isLocationModal:true, isEsicLocationModal:false }) }} className={`btn btn-success btn-label `} >
                                                    <span className="d-flex align-items-center gap-1">
                                                    <i className={` ri-play-list-add-line label-icon align-middle fs-16`} />
                                                    Add
                                                </span>
                                                </button>
                                            </div>)}
                                        </div>
                                        <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className=" ">
                                            <table style={{ minWidth: '100%',}} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative">
                                                <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                                    <tr>
                                                        <th style={{ width: "5%" }} className=' text-center'>Sr.No.</th>
                                                        <th>Location Title</th>
                                                        {/* <th>Valid Attendance Distance</th> */}
                                                        <th>Location Description</th>
                                                        <th>Location Address</th>
                                                        {/* <th>Auto Overtime Calculation</th> */}
                                                        { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                        <th className='text-center' width={120}>Action</th>)}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.rows.map((row,idx) => {
                                                            return <tr key={row.location_id}>
                                                                <td className=' text-center'>{idx+1}</td>
                                                                <td>{row.location_title}</td>
                                                                {/* <td>{row.valid_attendance_distance}</td> */}
                                                                <td>{row.location_description}</td>
                                                                <td>{row.location_address}</td>
                                                                {/* <td>{row.auto_ot_calculation_label}</td> */}
                                                                { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                                <td className='d-flex justify-content-around'>
                                                                    { this.state.decodedData?.includes(3) && (
                                                                        <button type='button' onClick={() => this.setState({ location_id: row.location_id }, (prevState) => this.GetInfo(row))} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>)}
                                                                    { this.state.decodedData?.includes(4) && (
                                                                        <button onClick={() => this.handleDelete(row.location_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                                </td>)}
                                                            </tr>
                                                        })
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                                <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} name="prev" type="button" onClick={(e) => this.handlePrev("1")} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                    {
                                                        <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                    }
                                                </div>
                                                <div className='col-md-2'>
                                                    <select name="total_pages" className="form-select" onChange={(e) => this.handleChange(e,"1")}>
                                                        {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                            <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <select className="form-select" onChange={(e) => {this.handleLimitChange(e,"1")}} value={this.state.limit}>
                                                        <option value={`${this.state.rows?.length}`}>All</option>
                                                        {limitOptions.map((option) => (
                                                            <option key={option} value={option}>Limit {option}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <button disabled={this.state.next === false && this.state.loadingList === false} name="next" type="button" onClick={(e) => this.handleNext("1")} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                        </div>
                                    </div>
                                </div>:
                                <div className="row">
                                    <div className=" card-body align-items-end justify-content-between d-flex">
                                        <div className='  '>
                                            <label htmlFor="keyword">Location Title</label>
                                            <div className="input-group">
                                                <input type="search" className="form-control" onChange={this.handleInputChange} name="esic_keyword" value={this.state.esic_keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search Location" />
                                                <button className="btn btn-success" onClick={this.handleInputSearch} type="button"><i className="ri-search-line"></i></button>
                                                <button className="btn btn-secondary ms-3" disabled={!this.state.esic_keyword} onClick={this.handleClearAll} type="button">Clear</button>
                                            </div>
                                        </div>
                                        { this.state.decodedData?.includes(2) && (
                                        <div className=''>
                                            <button style={{ float: "right"}} onClick={()=>{ this.setState({ esic_location_id:0, isEsicLocationModal:true, isLocationModal:false }) }} className={`btn btn-success btn-label `} >
                                                <span className="d-flex align-items-center gap-1">
                                                <i className={` ri-play-list-add-line label-icon align-middle fs-16`} />
                                                Add
                                            </span>
                                            </button>
                                        </div>)}
                                    </div>
                                    <div className="col-md-12">
                                        <div className=''>
                                            <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className=" ">
                                                <table style={{ minWidth: '100%',}} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative">
                                                    <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                                        <tr>
                                                            <th style={{ width: "5%" }} className=' text-center'>Sr.No.</th>
                                                            <th>ESIC Location Title</th>
                                                            {/* <th>Valid Attendance Distance</th>
                                                            <th>Location Description</th>
                                                            <th>Location Address</th>
                                                            <th>Auto Overtime Calculation</th> */}
                                                            { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                                <th className='text-center' width={120}>Action</th>)}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.esic_rows.map((row,idx) => {
                                                                return <tr key={row.esic_location_id}>
                                                                    <td className=' text-center'>{idx+1}</td>
                                                                    <td>{row.esic_location_title}</td>
                                                                    {/* <td>{row.valid_attendance_distance}</td>
                                                                    <td>{row.esic_location_description}</td>
                                                                    <td>{row.esic_location_address}</td>
                                                                    <td>{row.auto_ot_calculation_label}</td> */}
                                                                    { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                                    <td className='d-flex justify-content-around'>
                                                                        { this.state.decodedData?.includes(3) && (
                                                                            <button type='button' onClick={() => this.setState({ esic_location_id: row.esic_location_id }, (prevState) => this.GetInfo(row,"esic"))} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>)}
                                                                        { this.state.decodedData?.includes(4) && (
                                                                            <button onClick={() => this.handleDeleteEsicLocation(row.esic_location_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                                    </td>)}
                                                                </tr>
                                                            })
                                                        }

                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                                <button disabled={this.state.esic_prev === false && this.state.loadingList === false ? true : false} name="esic_prev" type="button" onClick={(e) => this.handlePrev("2")} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                    {
                                                        <small>Total Records: {this.state.esic_total_records} | Total Pages: {this.state.esic_total_pages} | Current Page: {this.state.esic_page}</small>
                                                    }
                                                </div>
                                                <div className='col-md-2'>
                                                    <select name="esic_total_pages" className="form-select" onChange={(e) => this.handleChange(e,"2")}>
                                                        {Array.from({ length: this.state.esic_total_pages }, (_, i) => (
                                                            <option selected={this.state.esic_page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                 <div className="col-md-2">
                                                    <select className="form-select" onChange={(e) => {this.handleLimitChange(e,"2")}} value={this.state.esic_limit}>
                                                        <option value={`${this.state.rows?.length}`}>All</option>
                                                        {limitOptions.map((option) => (
                                                            <option key={option} value={option}>Limit {option}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <button disabled={this.state.esic_next === false && this.state.loadingList === false} name="esic_next" type="button" onClick={(e) => this.handleNext("2")} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                }
                            </div>
                            {this.state.isLocationModal && (
                                <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}>
                                    <div className="m-auto mt-3 w-modal">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Loccation</h5>
                                            <button disabled={this.state.postLoading} onClick={() => { if(!this.state.postLoading){ this.setState({ isLocationModal:!this.state.isLocationModal },()=> this.resetForm()) } }} className="btn-close" aria-label="Close"/>
                                        </div>
                                        <div className="modal-body pt-0">
                                            <form className="row">
                                                <div className="col-md-12 mb-3">
                                                    <label htmlFor="location_title" className="form-label">Location title</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors.location_title ? 'is-invalid' : ''}`}
                                                        id="location_title"
                                                        name="location_title"
                                                        value={this.state.location_title}
                                                        disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Enter location title"
                                                    />
                                                    {errors.location_title && <div className="text-danger">{errors.location_title}</div>}
                                                </div>
                                                {/* <div className="col-md-6 ">
                                                    <label htmlFor="valid_attendance_distance" className="form-label">Valid Attendance Distance</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors.valid_attendance_distance ? 'is-invalid' : ''}`}
                                                        id="valid_attendance_distance"
                                                        name="valid_attendance_distance"
                                                        value={this.state.valid_attendance_distance}
                                                        disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Enter Valid Attendance Distance"
                                                    />
                                                    {errors.valid_attendance_distance && <div className="text-danger">{errors.valid_attendance_distance}</div>}
                                                </div> */}

                                                <div className="col-md-6">
                                                    <label htmlFor="location_description" className="form-label">Location description</label>
                                                    <textarea
                                                        type="text"
                                                        className={`form-control ${errors.location_description ? 'is-invalid' : ''}`}
                                                        id="location_description"
                                                        name="location_description"
                                                        value={this.state.location_description}
                                                        disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Enter Location description"
                                                    />
                                                    {errors.location_description && <div className="text-danger">{errors.location_description}</div>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="location_address" className="form-label">Location address</label>
                                                    <textarea
                                                        type="text"
                                                        className={`form-control ${errors.location_address ? 'is-invalid' : ''}`}
                                                        id="location_address"
                                                        name="location_address"
                                                        value={this.state.location_address}
                                                        disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Enter Location address"
                                                    />
                                                    {errors.location_address && <div className="text-danger">{errors.location_address}</div>}
                                                </div>

                                                {/* <div className="col-md-6 mt-3">
                                                    <label htmlFor="location_latlng" className="form-label">Location Lat/Lng <br /> <small className='text-muted'>(e.g., 37.7749,-122.4194)</small></label>
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors.location_latlng ? 'is-invalid' : ''}`}
                                                        id="location_latlng"
                                                        name="location_latlng"
                                                        value={this.state.location_latlng}
                                                        disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Enter Lat/Lng e.g., 37.7749,-122.4194"
                                                    />
                                                    {errors.location_latlng && <div className="text-danger">{errors.location_latlng}</div>}
                                                </div> */}

                                                {/* <div className="col-md-6 mt-3">
                                                    <div>
                                                        <label htmlFor="auto_ot_calculation" className="form-label">Auto Overtime Calculation:</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2" >
                                                        <input
                                                            type="radio"
                                                            id="auto_ot_calculation1"
                                                            name="auto_ot_calculation"
                                                            value="1"
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            checked={this.state.auto_ot_calculation == '1'}
                                                            onChange={() => this.handleRadioChange('auto_ot_calculation', '1')}
                                                            className={`form-check-input ${errors.auto_ot_calculation ? 'is-invalid' : ''}`}
                                                        />
                                                        <label htmlFor="auto_ot_calculation1" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="auto_ot_calculation0"
                                                            name="auto_ot_calculation"
                                                            value="0"
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            checked={this.state.auto_ot_calculation == '0'}
                                                            onChange={() => this.handleRadioChange('auto_ot_calculation', '0')}
                                                            className={`form-check-input ${errors.auto_ot_calculation ? 'is-invalid' : ''}`}
                                                        />
                                                        <label htmlFor="auto_ot_calculation0" className="form-check-label">No</label>
                                                    </div>
                                                    {errors.auto_ot_calculation && <div className="text-danger">{errors.auto_ot_calculation}</div>}
                                                </div> */}
                                                { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                    {
                                                        // this.state.location_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />
                                                        !this.state.decodedData?.includes(2) && this.state.decodedData?.includes(3)  ? (
                                                            <SubmitButton onClick={(e)=>{ 
                                                                this.setState({postLoading:true},()=> this.handleSubmit(e))
                                                            }}
                                                            loading={this.state.postLoading}
                                                            loadingMessage='Loading'
                                                            disabled={!this.state.location_id}
                                                            buttonName={'Update'} icon={'ri-save-line'} 
                                                            type='primary' iconSide='left' />) : (
                                                            <SubmitButton onClick={(e)=>{        
                                                                this.setState({postLoading:true},()=> this.handleSubmit(e))
                                                            }}
                                                            loading={this.state.postLoading}
                                                            loadingMessage='Loading'
                                                            buttonName={this.state.location_id ? 'Update':'Save'} icon={'ri-save-line'} 
                                                            type='primary' iconSide='left' />)
                                                    }

                                                    {/* {
                                                        this.state.location_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-light right btn-label`} onClick={() => this.resetForm()} ><i className={` ri-arrow-right-line label-icon align-middle fs-16 ms-2`} />{" "}New</button> : <div></div>
                                                    } */}
                                                </div>)}
                                            </form>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            )}
                            {this.state.isEsicLocationModal && (
                                <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}>
                                    <div className="m-auto mt-3 w-modal">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">ESIC Loccation</h5>
                                            <button disabled={this.state.postLoading} onClick={() => { if(!this.state.postLoading){ this.setState({ isEsicLocationModal:!this.state.isEsicLocationModal },()=> this.resetForm()) } }} className="btn-close" aria-label="Close"/>
                                        </div>
                                        <div className="modal-body pt-0">
                                            <form className="row">
                                                <div className="col-md-12">
                                                    <label htmlFor="esic_location_title" className="form-label">ESIC Location title</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors.esic_location_title ? 'is-invalid' : ''}`}
                                                        id="esic_location_title"
                                                        name="esic_location_title"
                                                        value={this.state.esic_location_title}
                                                        disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Enter location title"
                                                    />
                                                    {errors.esic_location_title && <div className="text-danger">{errors.esic_location_title}</div>}
                                                </div>
                                                { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                    {
                                                        // this.state.location_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />
                                                        !this.state.decodedData?.includes(2) && this.state.decodedData?.includes(3)  ? (
                                                            <SubmitButton onClick={(e)=>{ 
                                                                this.setState({postLoading:true},()=> this.handleSubmitEsic(e))
                                                            }}
                                                            loading={this.state.postLoading}
                                                            loadingMessage='Loading'
                                                            disabled={!this.state.location_id}
                                                            buttonName={'Update'} icon={'ri-save-line'} 
                                                            type='primary' iconSide='left' />) : (
                                                            <SubmitButton onClick={(e)=>{        
                                                                this.setState({postLoading:true},()=> this.handleSubmitEsic(e))
                                                            }}
                                                            loading={this.state.postLoading}
                                                            loadingMessage='Loading'
                                                            buttonName={this.state.location_id ? 'Update':'Save'} icon={'ri-save-line'} 
                                                            type='primary' iconSide='left' />)
                                                    }

                                                    {/* {
                                                        this.state.location_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-light right btn-label`} onClick={() => this.resetForm()} ><i className={` ri-arrow-right-line label-icon align-middle fs-16 ms-2`} />{" "}New</button> : <div></div>
                                                    } */}
                                                </div>)}
                                            </form>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(Locations);



